import { Input, Select } from 'components'

import {
	teamMembersState,
	setTeamMemberEmail,
	setTeamMemberRole,
	formErrorsState
} from '../state'
import { rolesState } from '../../team_info/state'

type Props = {
	index: number
}

export const TeamMemberInput = ({ index }: Props) => {
	const member = teamMembersState.value[index] || { email: '', role: '' }
	const emailError = formErrorsState.value[`email-${index}`]

	return (
		<div className='flex flex-col items-center gap-5 xl:flex-row'>
			<div>
				<span className='flex h-8 w-8 items-center justify-center rounded-full bg-black-800 text-white'>
					{index + 1}
				</span>
			</div>
			<div className='flex w-full flex-1 flex-col items-start gap-5 xl:flex-row'>
				<Input
					error={emailError}
					hasError={!!emailError}
					id={`email-${index}`}
					onInput={value => setTeamMemberEmail(index, value)}
					placeholder='email address'
					value={member.email}
					fullWidth
				/>
				<Select
					description='Select'
					id='role'
					onChange={(_, value) => setTeamMemberRole(index, value)}
					options={rolesState.value}
					value={member.role}
					fullWidth
				/>
			</div>
		</div>
	)
}
